<template>
  <div class="h-100">
    <!-- v-if="(habilitationsList && habilitationsList.length) || isFilterSelected" -->
    <div
      class="row"
      v-if="
        habilitationsList.length ||
        (!habilitationsList.length && isFilterSelected) ||
        (!isLoaded && (habilitationsList.length || isFilterSelected)) ||
        (!isLoaded && isFilterSelected && !habilitationsList.length)
      "
    >
      <div class="col-md-12">
        <ValidationObserver key="" ref="form" v-slot="{}">
          <div class="row d-flex justify-content-between mb-3">
            <div class="col-6 col-md-8">
              <div class="d-flex align-items-center">
                <div class="form-group w-md-75 mb-0">
                  <validation-provider
                    name="recherche"
                    rules="min:2"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      name="search"
                      v-model.trim="q"
                      class="form-control form-control_search"
                      :placeholder="$t('buttons.searchByNameQualif')"
                      :class="{ 'is-invalid': errors.length }"
                      v-debounce:1s.fireonempty="search"
                    />
                    <span class="text-danger small">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="col-md-4 d-flex justify-content-end">
              <button
                class="btn btn-icon ml-4"
                :class="
                  selectedFilterItems && selectedFilterItems.length
                    ? 'btn-dark'
                    : 'btn-filter '
                "
                type="button"
                @click.prevent.stop="showFilterModal"
              >
                <span
                  :class="
                    selectedFilterItems && selectedFilterItems.length
                      ? 'icon icon-filter-light'
                      : 'icon icon-filter'
                  "
                />
                <span class="">
                  {{ $t('filter') }}
                </span>
                <!-- <span v-if="filterData && filterData.length" class="ml-2 p-1 text-dark bg-white text-dark rounded-pill">{{ filterData.length }}</span> -->
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
      <div class="col-md-12 mb-3">
        <div class="legend justify-content-between">
          <div class="legend__items">
            <div class="legend__header">
              {{ $t('legend') }}
            </div>

            <div class="legend__item">
              <div class="icon icon-not-started"></div>
              <div>{{ $t('certificatePending') }}</div>
            </div>

            <div class="legend__item">
              <div class="icon icon-eye"></div>
              <div>{{ $t('viewCertificate') }}</div>
            </div>
          </div>
          <div>
            <div
              class="d-flex justify-content-end"
              v-if="
                (selectedFilterItems && selectedFilterItems.length) ||
                isFilterSelected
              "
            >
              <button
                class="btn btn-reset-filter btn-icon px-0"
                @click="resetFilter"
              >
                {{ $t('resetFilter') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isLoaded">
      <div class="row">
        <div class="col-md-12">
          <div
            class="box-block text-center"
            v-cloak
            v-if="!habilitationsList.length && isFilterSelected"
          >
            <div class="alert alert-primary mb-0">
              {{ $t('emptyFiltredHabilitationList') }}
            </div>
          </div>
          <div
            class="box-block text-center"
            v-cloak
            v-else-if="!habilitationsList.length"
          >
            <div class="alert alert-primary mb-0">
              {{ $t('emptyHabilitationsList') }}
            </div>
          </div>
          <div
            v-if="habilitationsList && habilitationsList.length"
            v-cloak
            class="dates dates_users"
          >
            <habilitation-table
              :habilitationsList="habilitationsList"
            ></habilitation-table>
            <div v-if="totalPages > 1">
              <div class="row mt-3 mb-5">
                <div
                  class="col-sm-12 d-flex justify-content-between"
                  v-if="totalPages > 1"
                >
                  <div class="">
                    <button
                      class="btn btn-filter btn-icon"
                      @click="previousPage()"
                    >
                      <span class="icon icon-arrow-left" />
                      {{ $t('previous') }}
                    </button>
                  </div>
                  <div>{{ $t('pagination', [page, totalPages]) }}</div>
                  <div class="">
                    <button class="btn btn-filter btn-icon" @click="nextPage()">
                      {{ $t('next') }} <span class="icon icon-arrow-right" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="row h-50 d-flex justify-content-center align-items-center"
    >
      <div class="col-12">
        <div class="d-flex justify-content-center align-items-center">
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="false">
      <div class="col-md-12"><add-new-habilitation /></div>
    </div>
    <confirmation-modal></confirmation-modal>
    <FilterModal />
  </div>
</template>

<script>
import FilterModal from '@/js/components/Profile/habilitations/FilterModal.vue'
import ConfirmationModal from '@/js/components/modals/ConfirmationModal.vue'
import HabilitationRow from './HabilitationRow.vue'
import HabilitationTable from './HabilitationTable.vue'
import AddNewHabilitation from './AddNewHabilitation.vue'
import { mapFields } from 'vuex-map-fields'
import { lazyInput } from 'vue-lazy-input'

export default {
  name: 'Habilitations',
  components: {
    ConfirmationModal,
    HabilitationRow,
    HabilitationTable,
    AddNewHabilitation,
    FilterModal,
  },
  directives: {
    lazyInput,
  },
  data() {
    return {
      page: 1,
      q: '',
      habilitationsList: [],
      form: {
        firstname: null,
        lastname: null,
        birthday: null,
        email: null,
        gender: 0,
      },
      isLoaded: false,
      locale: '',
      filterData: {},
      selectedFilterItems: [],
      lastTrimedQuery: '',
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
      queryPayload: {
        page: 1,
        limit: this.limit,
      },
    }
  },
  computed: {
    ...mapFields(['user', 'establishment']),
    ...mapFields([
      'habilitations.habilitations',
      'habilitations.pagination',
      'habilitations.limit',
      'habilitations.isFiltrSelected',
      'habilitations.orderDirection',
      'habilitations.orderBy',
    ]),
    clientType() {
      return this.$lodash.get(this.user, 'clientType', false)
    },
    totalPages() {
      return this.$lodash.get(this.pagination, 'total_pages', 1)
    },
    isFilterSelected() {
      if (
        this.q ||
        (this.selectedFilterItems && this.selectedFilterItems.length)
      ) {
        return true
      } else return false
    },
  },
  watch: {
    page: (val) => {
      if (val < 1) {
        this.page = 1
      }
    },
    orderDirection: {
      handler(val) {
        this.queryPayload = {
          ...this.$route.query,
          ...{
            page: this.$route.query.page || 1,
            limit: this.$route.query.limit || this.limit,
            ...this.filterData,
          },
          sort: val,
        }
        if (this.q != '') {
          let qArray = this.q.split(' ')
          let qFiltred = qArray.filter((word) => word.length > 2)
          let qString = qFiltred.join(' ')
          if (qString.length < 2) return
          this.queryPayload = {
            ...this.queryPayload,
            action: 'search',
            q: qString,
          }
        }
        this.$router.replace({ query: this.queryPayload }).catch((error) => {})
      },
      immediate: false,
    },

    $route: {
      handler(to, from) {
        if (this.$lodash.get(this.$route, 'query', false)) {
          console.log('this.$route.query ', this.$route.query)
          let payload = {
            ...{
              page: this.page,
              limit: this.limit,
              sort: this.orderDirection,
            },
            ...this.$route.query,
          }

          this.filterData = {
            startDateDlv: this.$route.query?.startDateDlv ?? null,
            endDateDlv: this.$route.query?.endDateDlv ?? null,
            startDate: this.$route.query?.startDate ?? null,
            endDate: this.$route.query?.endDate ?? null,
            iata: this.$route.query?.iata ?? null,
            ext: this.$route.query?.ext ?? null,
          }

          if (this.$route.query.startDateDlv) {
            this.selectedFilterItems.push(this.$route.query?.startDateDlv)
          }
          if (this.$route.query?.endDateDlv) {
            this.selectedFilterItems.push(this.$route.query?.endDateDlv)
          }
          if (this.$route.query?.startDate) {
            this.selectedFilterItems.push(this.$route.query?.startDate)
          }
          if (this.$route.query?.endDate) {
            this.selectedFilterItems.push(this.$route.query?.endDate)
          }
          if (this.$route.query?.iata) {
            this.selectedFilterItems.push(this.$route.query?.iata)
          }
          if (this.$route.query?.ext) {
            this.selectedFilterItems.push(this.$route.query?.ext)
          }
          console.log('this.$route.query?.startDateDlv ', this.$route.query.startDateDlv);
          this.page = this.$route.query?.page ?? this.page
          this.sort = this.$route.query?.sort ?? this.sort
          this.limit = this.$route.query?.limit ?? this.limit
          this.filter(payload)

        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.isFiltrSelected = false
    this.locale = this.user.local
    this.$bus.$on('update-habilitations-list', (toStart = true) => {
      this.queryPayload = {
        ...this.$route.query,
        ...{
          page: !toStart && this.$route.query.page ? this.$route.query.page : 1,
          limit: this.limit,
          sort: this.orderDirection,
        },
      }
      this.$router.replace({ query: this.queryPayload }).catch((error) => {})
    })

    this.$bus.$on('filter-habilitations', (data) => {
      this.selectedFilterItems = data?.filterData
      let params = data.data
      this.orderDirection = params.sort ?? '-issue_date'
      this.page = 1
      if (this.q) {
        params = {
          ...this.filterData,
          action: 'search',
          q: this.q,
        }
      }
      let payload = {
        params,
        id: this.user.id,
      }
      this.queryPayload = payload.params
      this.$router
        .replace({ query: this.queryPayload })
        .then(() => {
          this.filterData = data.data
          this.$bus.$emit('hide-filter-habilitation-modal')
        })
        .catch((error) => {
          console.log('error ', error)
          this.$bus.$emit('error-filter-habilitation-modal')
        })
    })
  },
  beforeMount() {
    this.$bus.$off('update-habilitations-list')
    this.$bus.$off('filter-habilitations')
  },
  methods: {
    resetFilter() {
      this.q = ''
      this.lastTrimedQuery = ''
      this.orderDirection = '-issue_date'
      this.page = 1
      this.filterData = {
        startDate: null,
        endDate: null,
        startDateDlv: null,
        endDateDlv: null,
        iata: null,
        category: null,
        ext: null,
        sort: '-issue_date',
      }
      this.queryPayload = {
        ...{ page: this.page, limit: this.limit },
      }

      this.selectedFilterItems = []
      this.$bus.$emit('reset-filter-habilitations')
      this.$router.replace({ query: this.queryPayload }).catch((error) => {})
    },
    showFilterModal() {
      this.$bus.$emit('filter-habilitation-modal.show')
    },
    nextPage() {
      if (
        this.pagination.total_pages > 1 &&
        this.page < this.pagination.total_pages
      ) {
        this.page++
        this.queryPayload = {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
          limit: this.limit,
          sort: this.orderDirection,
        }
        this.$router.replace({ query: this.queryPayload }).catch((error) => {})
      }
    },
    previousPage() {
      if (this.pagination.total_pages > 1 && this.page > 1) {
        this.page--
        this.queryPayload = {
          ...this.$route.query,
          ...this.filterData,
          sort: this.orderDirection,
          page: this.page,
          limit: this.limit,
        }
        this.$router.replace({ query: this.queryPayload }).catch((error) => {})
      }
    },
    filter(params) {
      this.isLoaded = false
      let payload = {
        params,
      }
      return this.$store
        .dispatch('habilitations/searchHabilitations', payload)
        .then((response) => {
          this.isFiltrSelected = true
          this.habilitationsList = this.habilitations
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
    search() {
      if (this.q != '') {
        let qArray = this.q.split(' ')
        let qFiltred = qArray.filter((word) => word.length > 2)
        let qString = qFiltred.join(' ')
        if (this.lastTrimedQuery == qString.trim()) {
          return
        }
        if (qString.length < 2) return
        this.isLoaded = false
        this.page = 1
        let payload = {
          params: {
            action: 'search',
            q: qString,
            sort: '-issue_date',
            page: this.page,
            limit: this.limit,
            ...this.filterData,
          },
          id: this.user.id,
        }
        console.log('payload params', payload.params)
        this.lastTrimedQuery = qString.trim()
        this.queryPayload = payload.params

        this.$router
          .replace({ query: this.queryPayload })
          .then(() => {
            this.isFiltrSelected = false
            this.orderDirection = '-issue_date'
          })
          .catch((error) => {})
      } else {
        this.page = 1
        this.queryPayload = {
          ...{ page: this.page, limit: this.limit },
          ...this.filterData,
          q: '',
        }
        console.log('this.queryPayload')
        this.lastTrimedQuery = ''
        this.$router
          .replace({ query: this.queryPayload })
          .then(() => {})
          .catch((error) => {})
      }
    },
    getHabilitations(params) {
      this.isLoaded = false
      this.$store
        .dispatch('habilitations/getHabilitations', params)
        .then(() => {
          this.habilitationsList = this.habilitations
        })
        .finally(() => {
          this.isLoaded = true
        })
    },

    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  },
}
</script>

<style></style>
